import type { Reducer } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';

import type { Actions as AddressActions, State as AddressState } from './address';
import address from './address';
import type { Actions as AppActions, State as AppState } from './app';
import app from './app';
import type { Actions as ComparablesActions, State as ComparablesState } from './comparables';
import comparables from './comparables';
import type { Actions as FilterActions, State as FilterState } from './filter';
import filter from './filter';
import type { Actions as UIActions, State as UIState } from './ui';
import ui from './ui';
import type { SetFilter, Actions as SetFilterActions } from './setFilter';
import setFilter from './setFilter';
import user from './user';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';
export interface RootState {
  address: AddressState;
  app: AppState;
  comparables: ComparablesState;
  filter: FilterState;
  ui: UIState;
  setFilter: SetFilter;
  user: ZrmClickstreamUser;
}

export type AllActions =
  | AddressActions
  | AppActions
  | ComparablesActions
  | FilterActions
  | UIActions
  | SetFilterActions;

const rootReducer: Reducer<RootState, AllActions> = combineReducers<RootState>({
  address,
  app,
  comparables,
  filter,
  ui,
  setFilter,
  user,
});

export default rootReducer;
